import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#textarea" }),
  /*#__PURE__*/_createTextVNode(" Textarea ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Resizable for entering multiple lines of text information. Add attribute "),
  /*#__PURE__*/_createVNode("code", null, "type=\"textarea\""),
  /*#__PURE__*/_createTextVNode(" to change "),
  /*#__PURE__*/_createVNode("code", null, "input"),
  /*#__PURE__*/_createTextVNode(" into native "),
  /*#__PURE__*/_createVNode("code", null, "textarea"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_input, {
        type: "textarea",
        rows: 2,
        placeholder: "Please input",
        modelValue: _ctx.textarea,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.textarea = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code6), 1)
        ]),
        _: 1
      })
    ])
  ]))
}